import * as yup from 'yup';

import { KpiTypeEnum } from '@/enums';
import { isNil } from 'ramda';

export function createCockpitGoalsFormSchema(
  kpiTypeByKpiId: Record<string, KpiTypeEnum>,
) {
  return yup.object({
    goals: yup
      .array(
        yup.object({
          kpiId: yup.string().uuid().required(),
          value: yup
            .number()
            .min(0)
            .nullable()
            .defined()
            .test(
              'percentage-max',
              'La valeur ne peut pas dépasser 100',
              function (value) {
                if (isNil(value)) return true;
                const { kpiId } = this.parent as { kpiId: string };

                return (
                  kpiTypeByKpiId[kpiId] !== KpiTypeEnum.PERCENTAGE ||
                  value <= 100
                );
              },
            ),
        }),
      )
      .required(),
  });
}

export type CockpitGoalsFormSchema = yup.InferType<
  ReturnType<typeof createCockpitGoalsFormSchema>
>;
